import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../Public/css/common.scss';

const CommonDateTimePicker = ({
    selected = null,
    onChange = () => {},
    showTimeSelect = true,
    className = 'custom-datepicker',
    dateFormat = 'dd-MM-yyyy',
    timeIntervals = 15,
    placeholderText = 'Select date and time',
    minDate = new Date(),
    maxDate = null,
    timeFormat = 'HH:mm:ss a',
    showTimeSelectOnly = false,
    disabled = false,
    dateRange = false,
    isClearable = false,
    startDate = null,
    endDate = null,
    minTime = null,
    maxTime = null,
    onBlur = () => {},
    placement = 'bottom',
}) => {
    return (
        <div className={className}>
            {!dateRange ? (
                <DatePicker
                    selected={selected}
                    onChange={onChange}
                    showTimeSelect={showTimeSelect}
                    dateFormat={dateFormat}
                    timeIntervals={timeIntervals}
                    placeholderText={placeholderText}
                    minDate={minDate}
                    maxDate={maxDate}
                    timeFormat={timeFormat}
                    showTimeSelectOnly={showTimeSelectOnly}
                    disabled={disabled}
                    isClearable={isClearable}
                    minTime={minTime}
                    maxTime={maxTime}
                    popperPlacement={placement}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />
            ) : (
                <DatePicker
                    selected={selected}
                    onChange={onChange}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    selectsRange
                    isClearable={isClearable}
                    placeholderText={placeholderText}
                    dateFormat={dateFormat}
                    onBlur={onBlur}
                    popperPlacement={placement}
                />
            )}
        </div>
    );
};

CommonDateTimePicker.propTypes = {
    className: PropTypes.string,
    selected: PropTypes.any,
    onChange: PropTypes.func,
    showTimeSelect: PropTypes.bool,
    dateFormat: PropTypes.string,
    timeIntervals: PropTypes.number,
    placeholderText: PropTypes.string,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    timeFormat: PropTypes.string,
    showTimeSelectOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    dateRange: PropTypes.bool,
    isClearable: PropTypes.bool,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    minTime: PropTypes.any,
    maxTime: PropTypes.any,
    onBlur: PropTypes.func,
    placement: PropTypes.string,
};

export default CommonDateTimePicker;
